import { connect } from 'react-redux';
import TermsAndConditions from '../../components/checkout/TermsAndConditions/TermsAndConditions';
import { PlansSelector } from '../reducers/PlansReducer';

const mapStateToProps = state => ({
  term: PlansSelector.getContractType(state),
  firstTerminationFee: 249,
  secondTerminationFee: 124,
  byoFirstTerminationFee: 99,
  byoSecondTerminationFee: 49,
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state)
});

export default connect(mapStateToProps, null)(TermsAndConditions);



/** WEBPACK FOOTER **
 ** ./src/redux/containers/TermsAndConditionsContainer.js
 **/